import {Component, Input, OnInit} from '@angular/core';
import {V3ExerciseSessionQuestionBase, V3FillMulti} from "../../../model/v3/cspa";

@Component({
    selector: 'app-fill-multi-result',
    templateUrl: './fill-multi-result.component.html',
    styleUrls: ['./fill-multi-result.component.scss'],
    standalone: false
})
export class FillMultiResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestionBase<V3FillMulti>[]

  constructor() { }

  ngOnInit(): void {
  }

  getQuestion(q: V3ExerciseSessionQuestionBase<V3FillMulti>) {
    return q.questionDef.question.replace(/{\d}/g, "...")
  }

  getStudentAnswer(q: V3ExerciseSessionQuestionBase<V3FillMulti>) {
    return q.questionDef.answerDef.answerHolder?.answer?.map(a => a.val.join("; ")) || "-"
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestionBase<V3FillMulti>) {
    return q.questionDef.answerDef.answer.map(a => a.val.join(", ")).join("; ")
  }

  isAnswerIncorrect(q: V3ExerciseSessionQuestionBase<V3FillMulti>) {
    return q.score == 0 && !!q.questionDef.answerDef.answerHolder
  }
}
